var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVisao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 104,
    viewBox: "0 0 598 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_28261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 54.7891V54.352L108.448 55.9254C104.63 56.3625 101.091 56.3625 97.3659 55.9254L82 54.1772",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 74.9366L114 82.2025H119",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 82.2025H93.2772L98 74.9366",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.733 88.5708C35.9058 84.0542 34.2094 78.6539 34.2094 72.8609C34.2094 56.6601 46.8377 43.7975 62.1047 43.7975C77.3717 43.7975 90 56.7582 90 72.8609C90 89.0617 77.5602 101.924 62.1047 101.924H0",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 101.924C160.829 101.924 173 88.9633 173 72.8607C173 56.6598 160.736 43.7975 145.5 43.7975C130.171 43.7975 118 56.758 118 72.8607C118 89.0615 130.264 101.924 145.5 101.924Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 68.19C111 72.9483 107.315 77.0126 103 77.0126C98.6854 77.0126 95 72.9483 95 68.19C95 63.4316 98.6854 59.3671 103 59.3671C107.315 59.3671 111 63.4316 111 68.19Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 94.6583C72.9174 94.6583 82 84.9953 82 73.3799C82 61.7646 72.9174 52.1013 62 52.1013C51.0826 52.1013 42 61.7646 42 73.3799C42 84.9953 51.0826 94.6583 62 94.6583Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 94.6583C156.69 94.6583 166 84.9953 166 73.3799C166 61.7646 156.69 52.1013 145.5 52.1013C134.31 52.1013 125 61.7646 125 73.3799C125 84.9953 134.31 94.6583 145.5 94.6583Z",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.954 53.6848V54.1773C129.146 47.9722 136.656 44.2294 144.907 44.2294C153.159 44.2294 155.013 45.7068 159 48.4646L148.152 34.9711C144.166 30.2434 139.437 27.1899 133.596 27.1899C127.755 27.1899 125.808 28.6674 122.748 30.9327C118.02 34.6755 112.642 37.4334 106.987 38.9108C104.669 39.4033 102.073 39.4033 99.6623 38.9108C94.0066 37.4334 88.6291 34.6755 83.9007 30.9327C80.8411 28.6674 77.1324 27.1899 73.053 27.1899C67.2119 27.1899 62.2053 29.9479 58.4967 34.9711L47 49.154C51.4503 45.9037 56.6424 44.1308 62.4834 44.1308C68.3245 44.1308 77.7815 47.8736 82.6954 53.5862",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 34.4557V33.4749C88 27.2961 82.6024 22 75.759 22C68.9157 22 65.5422 25.4326 64 30.2383",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 29.7691C139.317 25.0668 135.11 22 129.874 22C124.638 22 118 27.418 118 33.9603V35.4937",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 102H385.5H598",
    stroke: "#D70064",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_28261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 598,
    height: 104,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisao);
export default __webpack_public_path__ + "static/media/icon-visao.3a2c222c.svg";
export { ForwardRef as ReactComponent };